/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */
class GiftBag {
  selectors = {
    giftBagIdElement: "[gift-bag-id]",
    giftBagBlock: "[gift-bag-block]",
    cartItemsWrapper: "[data-items-wrapper]",
    cartItemsDrawer: "[data-cart-drawer]",
    giftBagLineItem(giftBagId) {
      return `[data-item*="${giftBagId}"]`;
    },
  };

  updateGiftBagObserver = new MutationObserver(() => {
    this.onCartUpdate();
  });

  isGiftBagInCart() {
    const giftBagId = document
      .querySelector(this.selectors.giftBagIdElement)
      ?.getAttribute("data-product-select");

    if (!giftBagId) return false;

    const lineItem = document.querySelector(
      this.selectors.giftBagLineItem(giftBagId)
    );

    return lineItem ? true : false;
  }

  toggleCheckBoxVisibility(visible) {
    const checkbox = document.querySelector(this.selectors.giftBagBlock);

    if (!checkbox) return;
    checkbox.classList.toggle("hidden", !visible);
  }

  onCartUpdate() {
    const isGiftBagInCart = this.isGiftBagInCart();
    this.toggleCheckBoxVisibility(!isGiftBagInCart);
  }

  observeCart() {
    let cartItemsContainer = document.querySelector(
      this.selectors.cartItemsWrapper
    );
    if (cartItemsContainer == null) {
      cartItemsContainer = document.querySelector(
        this.selectors.cartItemsDrawer
      );
    }
    this.updateGiftBagObserver.observe(cartItemsContainer, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
}

function clickbundleAddToCartButtonAutomatically() {
  document.addEventListener("DOMContentLoaded", function () {
    // Create a function that handles the observation of the button's disabled attribute
    function observeButton(btn) {
      // Create a MutationObserver to detect changes to the button's attributes
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === "disabled") {
            // Check if the disabled attribute was removed
            if (!btn.disabled) {
              btn.click(); // Automatically click the button
            }
          }
        });
      });

      // Configure the observer to watch for attribute changes
      observer.observe(btn, { attributes: true });
    }

    // Create a MutationObserver to detect when the .btn-add-to-cart button is added to the DOM
    const domObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.matches(".byob-footer")) {
            // Once the button is detected, start observing it
            observeButton(node.querySelector(".btn-add-to-cart"));
          }
        });
      });
    });

    // Start observing the document for changes in child elements (such as the button being added)
    domObserver.observe(document.body, {
      childList: true,
      subtree: true, // Watch for changes within all descendants
    });

    // Additionally, check if the button already exists on page load
    const initialButton = document.querySelector(
      ".byob-footer .btn-add-to-cart"
    );
    if (initialButton) {
      observeButton(initialButton);
    }
  });
}

function listenToCartRefreshEvent() {
  document.addEventListener("cart:refresh", () => {
    cart.getCart();
  });
}

async function updateCartItemCounterInHeader() {
  if (!cart.isCartDrawerLoaded) {
    await cart.renderCartDrawer(false);
  }

  const itemsInCart = cart.getCartItemCount();
  document.querySelectorAll(".cart-item-counter").forEach((e) => {
    e.textContent = itemsInCart;
    if (itemsInCart > 0) {
      e.classList.remove("hidden");
    } else {
      e.classList.add("hidden");
    }
  });
}

function listenToCartUpdateEvent() {
  document.addEventListener("DOMContentLoaded", function () {
    updateCartItemCounterInHeader();
  });

  document.addEventListener("theme:cart:update", () => {
    updateCartItemCounterInHeader();
  });
  document.addEventListener("theme:cart:added", () => {
    updateCartItemCounterInHeader();
  });
}

(function () {
  // Add custom code below this line
  const giftBag = new GiftBag();
  giftBag.observeCart();
  //clickbundleAddToCartButtonAutomatically();
  listenToCartRefreshEvent();
  listenToCartUpdateEvent();

   // Fix Country Scroll in Menü
  document.querySelector('.select-popout__list__scroll').addEventListener('touchmove', function (e) {
  e.stopPropagation();
}, { passive: false });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
